import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { Auth, API, graphqlOperation } from 'aws-amplify';
import { listCompanys, listProducts } from '../graphql/queries';
import { updateCompany } from '../graphql/mutations';
import PagerQuery from '../utils/PagerQuery';


import { Layout, Button, Card, Form, Input, Loading, Dialog, InputNumber, Notification } from 'element-react';
import MyPage from '../components/MyPage';

import 'react-image-crop/dist/ReactCrop.css';

//@ts-ignore
import createImg from '../assets/imgs/create-company.png';
import MyStoreCropImage from './MyStoreCropImage';

// Importaciones para Joyride
import Joyride, { STATUS, ACTIONS, EVENTS } from 'react-joyride';
import useShowWizardStore, { TOUR_KEYS } from '../store/joyride-dashboard';

function MyStore() {
    let history = useHistory();
    const { t } = useTranslation();

    const [formInputs, setFormInputs] = useState({
        file1: null, urlFile1: null, file2: null, urlFile2: null
    });
    const [loading, setLoading] = useState(false);
    const [dialogVisible, setDialogVisible] = useState(false);
    const [imageDialogVisible, setImageDialogVisible] = useState(false);
    const [companyPage, setCompanyPage] = useState(null);
    const [featuresProduct, setFeaturesProduct] = useState([]);
    const [fieldToUpdate, setFieldToUpdate] = useState('');
    const [showNoCompany, setShowNoCompany] = useState(false);
    const [showCompanyPreview, setShowCompanyPreview] = useState(false);
    const [showPublishModal, setShowPublishModal] = useState(true);

    // --- Estados para el Tour de MyStore ---
    const { show: showTourFlags, setShowTour } = useShowWizardStore();
    const [runNewCompanyPromptTour, setRunNewCompanyPromptTour] = useState(false);
    const [tourSource, setTourSource] = useState('onload'); // 'onload' o 'add-product'
    const [myStoreViewInSpanish, setMyStoreViewInSpanish] = useState(false); // Estado de idioma local para este tour
    const [promptTourDismissedInSession, setPromptTourDismissedInSession] = useState(false);

    // Estado para saber si estamos en vista móvil
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    // useEffect para actualizar el estado 'isMobile' si el usuario cambia el tamaño de la ventana
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);

        // Limpiamos el event listener cuando el componente se desmonte
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const toAddProduct = () => {
        if (companyPage && companyPage.published !== 1) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTourSource('add-product');
            setRunNewCompanyPromptTour(false);
            setPromptTourDismissedInSession(false);
            setTimeout(() => setRunNewCompanyPromptTour(true), 50);
        } else {
            history.push('/add-product-wizard/0');
        }
    }
    // ----------------------------------------------

    useEffect(() => {
        console.log('MyStore');
        searchCompanyData();
    }, [])

    // --- useEffect para controlar el tour (para ser un recordatorio) ---
    useEffect(() => {
        const conditionsMetForTour = !loading && companyPage && companyPage.published !== 1;

        if (conditionsMetForTour) {
            // Si las condiciones se cumplen y el usuario NO ha cerrado el tour en esta sesión
            // Y el tour no está ya corriendo, entonces inícialo.
            if (!promptTourDismissedInSession && !runNewCompanyPromptTour) {
                console.log("MyStore: Conditions met and not dismissed in session. Starting prompt tour.");
                setRunNewCompanyPromptTour(true);
            } else if (promptTourDismissedInSession && runNewCompanyPromptTour) {
                setRunNewCompanyPromptTour(false);
            }
        } else {
            if (runNewCompanyPromptTour) {
                setRunNewCompanyPromptTour(false);
            }
            // permitimos que el tour se pueda mostrar de nuevo la próxima vez que sean válidas.
            setPromptTourDismissedInSession(false);
        }
    }, [loading, companyPage, runNewCompanyPromptTour, promptTourDismissedInSession]);
    // ---------------------------------------------------------------------------------

    const searchCompanyData = async () => {
        console.log('searchCompanyData... from BD')
        setLoading(true);
        try {
            const user = await Auth.currentAuthenticatedUser();
            console.log('for user :: ' + user.username);
            const pagerQuery = new PagerQuery(listCompanys, { filter: { owner: { eq: user.username } } }, Object.keys({ listCompanys }));
            const result = await pagerQuery.searchPrivateData();
            console.log({ result })

            if (result.data.listCompanys.items.length > 0) {
                setCompanyPage(result.data.listCompanys.items[0]);
                setShowCompanyPreview(true);
            } else {
                setShowCompanyPreview(false);
                toCreateStore();
            }

            //@ts-ignore
            const pagerQueryProducts = new PagerQuery(listProducts, { filter: { and: { owner: { eq: result.data.listCompanys.items[0].owner }, status: { eq: 1 } } } }, Object.keys({ listProducts }));
            const resultProducts = await pagerQueryProducts.searchPrivateData();
            console.log({ resultProducts });
            setFeaturesProduct(resultProducts.data.listProducts.items);

        } catch (e) {
            console.error(e);
            setLoading(false);
        } finally {
            setLoading(false);
        }

    }

    const toCreateStore = () => {
        history.push("/my-store-wizard-ng/0/0");
    }

    const editCompanyText = (field) => {
        console.log("editCompanyText: ", field)
        setDialogVisible(true);
        setFieldToUpdate(field);
    }

    const editCompanyImage = (field) => {
        console.log("editCompanyImage: ", field)
        setImageDialogVisible(true);
        setFieldToUpdate(field);
    }

    const updateCompanyData = async () => {
        console.log('Update company');
        setLoading(true);
        try {
            const input = {
                id: companyPage.id,
                name: companyPage.name,
                type: companyPage.type,
                age: companyPage.age,
                description: companyPage.description,
                employees_qty: companyPage.employees_qty,
                titles: companyPage.titles,
                production_lines_qty: companyPage.production_lines_qty
            };
            const result = await API.graphql(graphqlOperation(updateCompany, { input }));
            console.log("Updated company", result);
            //@ts-ignore
            setCompanyPage(result.data.updateCompany);

        } catch (e) {
        } finally {
            setDialogVisible(false);
            setLoading(false);
        }

    }

    const cancelEditCompanyData = () => {
        setFormInputs({ ...formInputs, urlFile1: null })
        setDialogVisible(false);
        setImageDialogVisible(false);
        searchCompanyData();
    }

    const goToPublishMyStore = async () => {
        console.log('Update company - publish');

        if (companyPage.company_logo?.key === null || companyPage.company_logo?.key === undefined
            || companyPage.cover_picture?.key === null || companyPage.cover_picture?.key === undefined
        ) {
            Notification({
                title: 'Warning',
                message: <>
                    You cannot publish without pictures.<br /><br />
                    Please upload the Cover and About Us pictures below and then hit Publish again.
                </>,
                type: 'error',
                duration: 15000,
                iconClass: 'el-icon-warning',
            });
            //alert("Please upload a cover picture and logo company to pulish.");
            return;
        }

        setLoading(true);
        try {
            const input = {
                id: companyPage.id,
                published: 1
            };
            const result = await API.graphql(graphqlOperation(updateCompany, { input }));
            console.log("Updated company", result);
            //@ts-ignore
            setCompanyPage(result.data.updateCompany);
        } catch (e) {
            console.error(e);
        }
        finally {
            setLoading(false);
        }
    }

    const goToEditMyStore = async () => {
        history.push('/my-store-wizard-ng/' + companyPage.id + '/0');
    }

    // --- Definición de los pasos para el tour ---
    const newCompanyPromptSteps = [
        {
            content: (
                <div className="custom-joyride-content-mystore-prompt"> {/* Clase para los estilos*/}
                    <button
                        className={`custom-joyride-button ${myStoreViewInSpanish ? 'spanish-active' : ''}`}
                        onClick={() => setMyStoreViewInSpanish(prev => !prev)}
                        style={{ marginTop: '45px', marginRight: '25px' }} // Estilo de ejemplo
                    >
                        <span>English</span>
                        <span>Español</span>
                    </button>
                    {tourSource === 'add-product' ? (
                        <p style={{ fontWeight: 'bold' }}>
                            {myStoreViewInSpanish 
                                ? "Para subir productos primero publica tu empresa."
                                : "You must publish your Microsite before adding products."}
                        </p>
                    ) : (
                        <>
                            <p>{myStoreViewInSpanish ? "Atención: ¡Tu micrositio aun no es visible!"
                                : "Your site is not visible yet!"}</p>
                            <p>{myStoreViewInSpanish ? "Esta es una vista preliminar de tu sitio."
                                : "This is a preliminary view of your site for you to review."}</p>
                            <p>{myStoreViewInSpanish ? <>Por favor revisa la información, si necesitas editarlo haz clic en <span className='styleSpan'>Edit Page.</span></>
                                : <>If you need to edit something click on <span className='styleSpan'>Edit Page.</span></>}</p>
                            <p>{myStoreViewInSpanish ? <>Si estás listo, da clic en <span className='styleSpan'>Publish</span> para hacerlo visible en Bainub.</>
                                : <>When ready, click on <span className='styleSpan'>Publish</span> to go online in Bainub.</>}</p>
                        </>
                    )}
                </div>
            ),
            target: '.my-store-actions-row',
            placement: 'bottom', // Para que apunte hacia arriba a los botones
            disableBeacon: true, // Para que aparezca directamente
            //isFixed: true, // Puede ayudar si hay scrolling
            spotlightClicks: false, // No queremos que el click en el spotlight avance            
        }
    ];
    // -----------------------------------------------

    // --- Callback para el tour (para recordatorio) ---

    const handleNewCompanyPromptTourCallback = (data) => {
        const { status, action, lifecycle, type } = data;
        const RENDER = lifecycle === 'render' || lifecycle === 'update';
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (RENDER) {
            return;
        }
        console.log("MyStore Tour Callback (Reminder Mode - Loop Fixed):", { type, status, action, lifecycle });

        if (finishedStatuses.includes(status) || action === ACTIONS.CLOSE) {
            console.log("MyStore Tour: Prompt dismissed by user. Hiding for now and marking as dismissed in session.");
            setRunNewCompanyPromptTour(false);
            setPromptTourDismissedInSession(true);
        }
    };
    // ---------------------------------------------

    // objetos de estilos, uno para escritorio y otro para móvil
    const joyrideDesktopStyles = {
        options: {
            zIndex: 15000,
            arrowColor: '#fff',
            width: '550px' // Ancho para escritorio
        },
        tooltip: {
            justifyContent: 'center'
        },
        buttonNext: {
            backgroundColor: '#F76566',
            borderRadius: '20px',
            width: '110px',
            height: '37px',
            margin: '-20px 400px 5px 0px' // Margen para escritorio
        },
    };

    const joyrideMobileStyles = {
        options: {
            zIndex: 15000,
            arrowColor: '#fff',
            // Ancho flexible que se adapta a la pantalla del móvil
            width: '85vw'
        },
        tooltip: {
            justifyContent: 'center'
        },
        buttonNext: {
            backgroundColor: '#F76566',
            borderRadius: '20px',
            width: '110px',
            height: '37px',
            // Margen centrado y normal para móvil
            margin: '10px auto'
        },
    };

    if (loading) return <Loading fullscreen={loading} />

    return <div>

        {imageDialogVisible ? <MyStoreCropImage
            visible={imageDialogVisible}
            onCancelDialogCallback={() => {
                console.log("onCancelDialogCallback callback!");
                setImageDialogVisible(false);
            }}
            onSaveImageCallback={(companyPageUpdated) => {
                console.log("onSaveImageCallback callback!");
                setImageDialogVisible(false);
                setCompanyPage(companyPageUpdated)
            }}
            fieldToUpdate={fieldToUpdate}
            s3KeyPrefix={`/${companyPage.name}/${fieldToUpdate}`}
            companyPageId={companyPage.id}
        /> : <></>

        }

        {
            /*
            companyPage?.published === 0 && 
            showPublishModal ?
            <Dialog size="tiny"
                    visible={showPublishModal}
                    onCancel={() => setShowPublishModal(false)}
            >
                <Dialog.Body>
                    <div>
                    This is the preliminary view of your company site.

                        It is not public yet.

                        Please check it and edit what you think its necessary.

                        If your site is ready to go online click on Publish Now button.

                        ( Ok )
                    </div>
                </Dialog.Body>
                <Dialog.Footer className="dialog-footer">
                    <form-button-inverse style={{'padding-right': '10px'}}>
                        <Button onClick={() => setShowPublishModal(false)}>Ok</Button>
                    </form-button-inverse>
                </Dialog.Footer>
                
            </Dialog> : <></>
            */
        }


        <Dialog size="tiny"
            visible={dialogVisible}
            onCancel={() => cancelEditCompanyData()}
        >
            <Dialog.Body>
                <Form label-position="top">
                    <Form.Item>
                        {fieldToUpdate === 'employees_qty' || fieldToUpdate === 'production_lines_qty' ?
                            <InputNumber
                                defaultValue={companyPage?.[fieldToUpdate]}
                                onChange={(v) => {
                                    setCompanyPage({ ...companyPage, [fieldToUpdate]: v })
                                }}
                            /> : <Input
                                type={fieldToUpdate === 'description' ? 'textarea' : 'text'}

                                rows={5}

                                value={companyPage?.[fieldToUpdate]}
                                onChange={(v) => {
                                    setCompanyPage({ ...companyPage, [fieldToUpdate]: v })
                                }}
                            />}
                    </Form.Item>
                </Form>
            </Dialog.Body>
            <Dialog.Footer className="dialog-footer">
                <form-button-inverse style={{ 'padding-right': '10px' }}>
                    <Button onClick={() => cancelEditCompanyData()}>Cancelar</Button>
                </form-button-inverse>
                <form-button>
                    <Button type="primary" onClick={() => updateCompanyData()}>Actualizar</Button>
                </form-button>
            </Dialog.Footer>
        </Dialog>


        {showCompanyPreview ? <Layout.Row type="flex">
            <Layout.Col span="24" offset="1" xs={{ span: 24, offset: 0 }} sm="20" lg="22">
                {<Card className="box-card warning-card">
                    <Layout.Row type="flex">
                        <Layout.Col span="24" offset="1" xs="20" sm="20" lg="20">
                            <span>&nbsp;</span>
                            {
                                companyPage?.published == 1
                                    ?
                                    <h2 className="white-text reduce-top-space">{t('my-store.warning1')}</h2>
                                    :
                                    <>
                                        <h2 className="white-text reduce-top-space">
                                            Your store has been created! <br />
                                        </h2>
                                        <h3 className="white-text reduce-top-space">
                                            Please review your store and publish it when ready.
                                        </h3>
                                    </>

                            }

                        </Layout.Col>
                    </Layout.Row>
                    <Layout.Row className="bottom-separator rigth-separator" type="flex" justify="start">
                        <div className='my-store-actions-row' style={{ width: '46%' }}>
                            <Layout.Col tag="form-button-warning-white" span="24" offset="1" xs="20" sm="20" lg="20">
                                <Button type="primary" onClick={goToEditMyStore}>
                                    {t('my-store.button-to-edit')}
                                </Button>
                            </Layout.Col>
                            <Layout.Col tag="form-button-warning-white">
                                <Button className="btn-add-products1" onClick={toAddProduct} type="primary">
                                    <i className="el-icon-plus"></i> {t('my-store.page.button-add-product')}
                                </Button>
                            </Layout.Col>
                            {
                                companyPage?.published == 1 ?
                                    <></>
                                    :
                                    <Layout.Col tag="form-button-warning-white" span="24" offset="1" xs="20" sm="20" lg="20">
                                        <Button type="primary" onClick={goToPublishMyStore}>
                                            Publish
                                        </Button>
                                    </Layout.Col>

                            }
                        </div>
                    </Layout.Row>

                </Card>}
            </Layout.Col>
        </Layout.Row> : <></>}

        {companyPage !== null ? <MyPage featuresProduct={featuresProduct} editCompanyText={editCompanyText}
            editCompanyImage={editCompanyImage} owner={true}
            toAddProduct={toAddProduct}
            companyPage={companyPage} /> : <></>}

        {/* --- Componente Joyride para el tour --- */}
        {runNewCompanyPromptTour && (
            <Joyride
                steps={newCompanyPromptSteps}
                run={runNewCompanyPromptTour}
                callback={handleNewCompanyPromptTourCallback}
                continuous={true}
                showSkipButton={false}
                disableOverlayClose={true}
                disableScrollParentFix={true}
                locale={{
                    last: myStoreViewInSpanish ? 'Entendido' : 'Ok', // texto del botón final
                }}
                // estilos correspondientes según si es móvil o no
                styles={isMobile ? joyrideMobileStyles : joyrideDesktopStyles}
            />
        )}
        {/* ----------------------------------------- */}

    </div>
}

export default MyStore;